import React, { useEffect, useState } from "react";
import SmokeReveal from "./SmokeReveal";

const getTimeGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 5) return "Good night";
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};

function LuxuryQuoteOverlay() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setShow(true), 4000);
    const t2 = setTimeout(() => setShow(false), 11000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);
  return (
    <span className={`absolute left-1/2 bottom-16 -translate-x-1/2 text-gold/80 font-serif italic text-lg md:text-2xl px-6 py-2 bg-brand-dark/80 rounded-xl shadow-lg drop-shadow-lg pointer-events-none transition-all duration-1000 ${show ? "opacity-100" : "opacity-0"}`}>
      Luxury is in every detail.<br />Intelligence, in every inch.
    </span>
  );
}

export default function Hero() {
  const [city, setCity] = useState(null);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then(res => res.json())
      .then(data => setCity(data.city));
  }, []);

  return (
    <section id="hero" className="relative h-screen flex flex-col items-center justify-center text-center pt-28 overflow-hidden">
      <SmokeReveal />

      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-purple-900" />

      <div className="relative z-10 max-w-4xl px-6 space-y-6">
        <span className="block text-gold/80 text-lg mb-2 font-serif tracking-widest">
          {getTimeGreeting()}, welcome to Senshoha Systems
          {city && <span className="ml-2 text-gold font-bold">| Smarter homes in {city}</span>}.
        </span>
        <span className="inline-block mb-6 px-6 py-2 bg-gold/10 text-gold font-semibold font-serif tracking-widest rounded-full shadow border border-gold/30 backdrop-blur-sm">
          Intelligence in Every Inch
        </span>
        <h1 className="text-4xl md:text-6xl font-serif font-bold mb-6 drop-shadow-lg">
          Elevate Your Home with <span className="text-gold">Senshoha</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-300 mb-10">
          Integrated IoT solutions for secure doors with dual authentication,<br />
          automated pool covers with safety sensors, and adjustable electrochromic windows.<br />
          All unified for peace of mind.
        </p>
        <a
          href="#contact"
          className="inline-block bg-gold text-brand-dark font-bold px-10 py-4 rounded-lg shadow-lg hover:bg-white hover:text-gold transition-all ring-2 ring-gold/30"
        >
          Schedule Consultation
        </a>
        <LuxuryQuoteOverlay />
      </div>
    </section>
  );
}
